// Module
var code = `<div class="js-tercera-multilineLabel-container" {{^.enabled}} disabled="" {{/}} style="{{>visibility}};"
    as-tooltip="showTooltip?.tooltip:''">
    {{#.lines:l_i}}
    <terceraLabel text="{{lines[l_i]}}" additionalClass="js-tercera-multilineLabel" />
    {{/}}
    <!-- <div as-tooltip="showTooltip?.tooltip:''"> </div> -->
</div>`;
// Exports
export default code;